// @ts-expect-error this library is not typed
import { LightenDarkenColor } from "lighten-darken-color";

export const lightenDarkenColor = (color: string, amount: number) => {
  return LightenDarkenColor(color, amount) as string;
};
